module.exports = __webpack_public_path__ + "static/media/meritus-5.226ebbbd.jpg";